function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.684 5.051a1 1 0 01.632 0l15 5a1 1 0 010 1.898L25 14.054V24a1 1 0 01-.702.954l-8 2.5a1 1 0 01-.596 0l-8-2.5A1 1 0 017 24v-9.946l-5-1.667V19a1 1 0 11-2 0v-8a1 1 0 01.684-.949l15-5zM4.162 11L16 14.946 27.838 11 16 7.054 4.162 11zM9 14.72v8.545l7 2.187 7-2.187V14.72l-6.684 2.228a1 1 0 01-.632 0L9 14.72z",
  fill: "currentColor"
})));